import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../../js/app/react/validators';
import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { BACKEND_KEY } from '../IncomeWorkflowConstants';
import AdvForm from '../../../CommonComponents/AdvForm';
import { validateYearlySalary } from '../IncomeWorkflowValidators';
import { isVisible } from '../../AdvWorkflow/AdvWorkflowHelpers';
import InputDollar from '../../InputDollar/InputDollarView';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';
import yearlySalaryShouldSkip from './YearlySalaryShouldSkip';

const PRINCIPAL_INCOME_INDEX = 0;
const SPOUSE_INCOME_INDEX = 1;

class YearlySalaryView extends Component {
  componentDidUpdate(previousProps) {
    const { branch, iterator, fetchData, workflowId, clientId } = this.props;

    if (!isVisible(previousProps.branch, previousProps.iterator) && isVisible(branch, iterator)) {
      fetchData(workflowId, clientId);
    }
  }

  render() {
    const {
      branch,
      workflowId,
      clientId,
      hasPartner,
      yearlySalary,
      earner,
      partnerYearlySalary,
      earnerPartner,
      store,
      incomeChanged,
      incomes,
      isGoingForward,
    } = this.props;
    return (
      <AdvWorkflowStep
        branch={branch}
        workflowId={workflowId}
        canSkip={yearlySalaryShouldSkip(
          isGoingForward,
          hasPartner,
          yearlySalary,
          partnerYearlySalary,
        )}
      >
        <Validation workflowId={workflowId} validationId={`${BACKEND_KEY}.YearlySalary`} />

        <h2>{hasPartner ? 'What are your yearly salaries?' : 'What is your yearly salary?'}</h2>
        <AdvForm>
          <ul className="horizontal">
            <li>
              <InputDollar
                isUnder
                maxLength="256"
                placeholderClassName="adv-workflows-placeholder-large"
                placeholder={earner}
                className="md"
                value={yearlySalary}
                id={`adv-${earner}-yearly-salary`}
                onChange={incomeChanged(
                  incomes,
                  PRINCIPAL_INCOME_INDEX,
                  clientId,
                  store(workflowId),
                )}
              />
            </li>
            {hasPartner && (
              <li>
                <InputDollar
                  isUnder
                  placeholderClassName="adv-workflows-placeholder-large"
                  placeholder={earnerPartner}
                  className="md"
                  value={partnerYearlySalary}
                  id={`adv-${earnerPartner}-yearly-salary`}
                  onChange={incomeChanged(
                    incomes,
                    SPOUSE_INCOME_INDEX,
                    clientId,
                    store(workflowId),
                  )}
                />
              </li>
            )}
          </ul>
        </AdvForm>

        <Navigation
          nextIterators={[]}
          dirtyGraphNodes={[]}
          validator={validateYearlySalary(hasPartner, yearlySalary, partnerYearlySalary)}
          validationId={`${BACKEND_KEY}.YearlySalary`}
          workflowId={workflowId}
          backendKey={BACKEND_KEY}
          validatedOnClick={() => workflowAnalyticsEvents(workflowId, 'salaries_completed')}
        />
      </AdvWorkflowStep>
    );
  }
}

YearlySalaryView.defaultProps = {
  earnerPartner: null,
  partnerYearlySalary: null,
  iterator: null,
  hasPartner: false,
};

YearlySalaryView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  iterator: PropTypes.arrayOf(PropTypes.number.isRequired),
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  store: PropTypes.func.isRequired,
  incomeChanged: PropTypes.func.isRequired,
  hasPartner: PropTypes.bool,
  incomes: PropTypes.arrayOf(PropTypes.shape({ Amount: PropTypes.number })).isRequired,
  earner: createCustomPropType(isNonEmptyString).isRequired,
  yearlySalary: createCustomPropType(isNumeric).isRequired,
  earnerPartner: createCustomPropType(isNonEmptyString),
  partnerYearlySalary: createCustomPropType(isNumeric),
  fetchData: PropTypes.func.isRequired,
  isGoingForward: PropTypes.bool.isRequired,
};

export default YearlySalaryView;
